import { render, staticRenderFns } from "./GridAudioguides.vue?vue&type=template&id=27b53d44&"
import script from "./GridAudioguides.vue?vue&type=script&lang=js&"
export * from "./GridAudioguides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b53d44')) {
      api.createRecord('27b53d44', component.options)
    } else {
      api.reload('27b53d44', component.options)
    }
    module.hot.accept("./GridAudioguides.vue?vue&type=template&id=27b53d44&", function () {
      api.rerender('27b53d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/audioguides/grid/GridAudioguides.vue"
export default component.exports